// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zWrD","col":"styles_col__1-EgJ"};